import {SetPostAuthorization} from './thunk/setAuthorization';
import {SetPostAuthorizationRoot} from './thunk/setAuthorizationRoot';
import {SetAuthorize} from './thunk/setAuthorize';
import {SetAuthorizeRoot} from './thunk/setAuthorizeRoot';

export const Thunks = {
    SetPostAuthorization,
    SetPostAuthorizationRoot,
    SetAuthorize,
    SetAuthorizeRoot
}